
module.config(function($stateProvider, moment) {

    $stateProvider.state('program.overview', {
        url: '',
        templateUrl: 'programs/overview/page',
        permission: 'viewStudents',
        instead: '^.info.details',
        resolve: {
            overview: function(program, ModelService) {
                return ModelService.getModelRelation(program, 'overview');
            },
            changes: function(program, ModelService) {
                return ModelService.getModelRelation(program, 'recent/students');
            },
            submission: function(program, ModelService) {
                return ModelService.getModelRelation(program, 'submissions/last');
            },
        },
        controllerAs: 'ctrl',
        controller: module.cC({
            inject: ['$scope', 'overview',
                     'changes', '$state', 'submission', 'ModelService'],
            data: {
                'overview': 'overview',
                'changes': 'changes',
                'minYear': '2010',
                'maxYear': moment().year(),
                'reportYear': moment().year(),
            },
            methods: {
                submitData: function(program) {
                    return this.ModelService.postModelRelation(program, 'submissions', {});
                },
                refreshSubmission: function(program) {
                    var self = this;
                    return this.ModelService.getModelRelation(program, 'submissions/last')
                        .then(function(submission) {
                            angular.copy(submission, self.submission);
                        });
                },
            }
        }),
    });
});

